<template>
  <div class="menu">
    <AppMenuItem
      v-for="{ value, label } of items"
      :key="value"
      :value="value"
      :label="label"
      :isActive="modelValue === value"
      class="menu__item"
      @click="onClickMenuItem(value)"
    />
  </div>
</template>

<script>
import AppMenuItem from './AppMenuItem'

export default {
  name: 'AppMenu',
  components: {
    AppMenuItem
  },
  props: {
    // { value: '', label: '' }
    items: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [Number, String],
      default: null
    }
  },
  methods: {
    onClickMenuItem (value) {
      this.$emit('update:modelValue', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  display: flex;
}
</style>
